import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_DASHBOARD,
    SG_GET_DASHBOARD,
    GET_DASHBOARD_SYSTEM_OVERVIEW,
    SG_GET_DASHBOARD_SYSTEM_OVERVIEW,
    GET_DASHBOARD_ORGANIZATION_USAGE,
    SG_GET_DASHBOARD_ORGANIZATION_USAGE,
    GET_DASHBOARD_PERFORMANCE_METRICS,
    SG_GET_DASHBOARD_PERFORMANCE_METRICS,
} from "constants/actions";

function* loadDashboard(action) {
    try {
        // The root dashboard endpoint was removed; build a combined dashboard
        // by calling the three available sub-endpoints and combining results.
        const sys = yield call(api.DASHBOARD_SYSTEM_OVERVIEW);
    // allow passing a serialized query string (page, page_size, ordering)
    const org = yield call(api.DASHBOARD_ORGANIZATION_USAGE, action.payload?.organization_usage_query);
        const perf = yield call(api.DASHBOARD_PERFORMANCE_METRICS);

        const payload = {
            system_overview: sys.data,
            organization_usage: org.data,
            performance_metrics: perf.data,
        };

        yield put({ type: GET_DASHBOARD, payload });
    } catch (e) {
        // If any of the sub-calls fail, let the existing handlers manage errors
        yield call(handleError, e);
    }
}

export function* dashboardLoad() {
    yield takeLatest(SG_GET_DASHBOARD, loadDashboard);
}

function* loadSystemOverview() {
    try {
        const json = yield call(api.DASHBOARD_SYSTEM_OVERVIEW);
        yield put({ type: GET_DASHBOARD_SYSTEM_OVERVIEW, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* systemOverviewLoad() {
    yield takeLatest(SG_GET_DASHBOARD_SYSTEM_OVERVIEW, loadSystemOverview);
}

function* loadOrganizationUsage(action) {
    try {
        // accept a serialized query string in action.payload (e.g. 'page=2')
        const json = yield call(api.DASHBOARD_ORGANIZATION_USAGE, action.payload);
        yield put({ type: GET_DASHBOARD_ORGANIZATION_USAGE, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* organizationUsageLoad() {
    yield takeLatest(SG_GET_DASHBOARD_ORGANIZATION_USAGE, loadOrganizationUsage);
}

function* loadPerformanceMetrics() {
    try {
        const json = yield call(api.DASHBOARD_PERFORMANCE_METRICS);
        yield put({ type: GET_DASHBOARD_PERFORMANCE_METRICS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* performanceMetricsLoad() {
    yield takeLatest(SG_GET_DASHBOARD_PERFORMANCE_METRICS, loadPerformanceMetrics);
}

export default function* index() {
    yield all([
        dashboardLoad(),
        systemOverviewLoad(),
        organizationUsageLoad(),
        performanceMetricsLoad(),
    ]);
}
